import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const CustomVsStandardSoftware8 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="customVsStandardSoftware" section="middleGround">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="customVsStandardSoftware:middleGround" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default CustomVsStandardSoftware8;
